import { Controller } from "@hotwired/stimulus"

// Una parte della pagina riletta con morph (passo 4: le risposte delle scritture e il frame ricaricato dopo un dato
// tecnico) lascia i <details> come li ha lasciati chi guarda, come lo stato di React dopo load() (le condizioni
// tecniche di ControlliTecnici restano aperte dopo «Conferma»). Riquadro e Mostra tengono il loro stato da sé
// (riquadro_controller.js).
//   <div data-controller="dettagli-aperti" data-action="turbo:before-morph-attribute->dettagli-aperti#attributo">
export default class extends Controller {
  attributo(event) {
    if (event.target.tagName === "DETAILS" && event.detail.attributeName === "open") event.preventDefault()
  }
}
